<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="hasInterviews ? title : ''"
    width="480px"
    :close-on-click-modal="false"
    custom-class="submit-dialog"
    :modal="true"
    :append-to-body="true"
    :lock-scroll="true"
    :show-close="false"
    @close="handleClose"
  >
    <template slot="title">
      <div class="dialog-title" v-if="hasInterviews">
        <span class="title-text">{{ title }}</span>
        <img src="../../assets/image/close.svg" alt="关闭图标" @click="handleClose"/>
      </div>
    </template>
    <div class="submit-content" :class="containerClass">
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <div class="loading-text">正在加载材料...</div>
      </div>

      <template v-else>
        <div class="section" v-if="hasInterviews">
          <div class="material-list">
            <div
              v-for="interview in interviewList"
              :key="'interview-' + interview.id"
              class="material-item"
              :class="{ active: selectedInterviewId === interview.id }"
              @click="selectedInterviewId = interview.id"
            >
              <div class="material-icon"></div>
              <div class="material-info">
                <div class="material-name">{{ interview.interview_name || interview.name || '面试记录' }}</div>
                <div class="material-date">{{ formatInterviewDate(interview.create_time || interview.createTime) }} 面试存档</div>
              </div>
              <div class="material-radio">
                <input type="radio" :name="'interview'" :checked="selectedInterviewId === interview.id" />
              </div>
            </div>
          </div>
        </div>
        <div class="empty-block" v-else>
          <div class="empty-icon"><img :src="noFoundImg" alt="暂无数据"></div>
          <div class="empty-title">暂无面试记录</div>
          <div class="empty-desc">去创建一场面试后再来投递吧</div>
        </div>
      </template>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" :disabled="submitting">取消</el-button>
      <el-button type="primary" :disabled="!canSubmit || submitting" v-if="hasInterviews" @click="startSubmit">
        {{ submitting ? '提交中...' : '立即投递' }}
      </el-button>
      <el-button type="primary" class="button-color" v-else @click="goToInterview">立即面试</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getUserInterviewList } from '@/api/mianshilishi'

export default {
  name: 'SubmitMaterialDialog',
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '请选择面试记录' }
  },
  data () {
    return {
      innerVisible: false,
      loading: false,
      submitting: false,
      interviewList: [],
      selectedInterviewId: null,
      noFoundImg: require('@/assets/image/noFound.png')
    }
  },
  computed: {
    canSubmit () {
      return !!this.selectedInterviewId
    },
    containerClass () {
      return 'single-section'
    },
    hasInterviews () {
      return Array.isArray(this.interviewList) && this.interviewList.length > 0
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (v) {
        this.innerVisible = v
        if (v) this.loadData()
      }
    },
    innerVisible (v) {
      this.$emit('update:visible', v)
    }
  },
  methods: {
    async loadData () {
      this.loading = true
      this.interviewList = []
      this.selectedInterviewId = null
      try {
        const resI = await getUserInterviewList({ pageNo: 1, pageSize: 50 })
        if (resI && resI.data && resI.data.code === 1) {
          this.interviewList = resI.data.data?.lists || resI.data.data || []
        }
      } catch (e) {
        this.$message.error('加载材料失败，请重试')
      } finally {
        this.loading = false
      }
    },
    handleClose () {
      this.innerVisible = false
    },

    startSubmit () {
      if (!this.canSubmit || this.submitting) return
      if (!this.canSubmit) return
      this.submitting = true
      const payload = {
        interviewId: this.selectedInterviewId || null,
        interview: this.interviewList.find(i => i.id === this.selectedInterviewId) || null
      }
      // 完全交给父组件处理提交与后续逻辑
      this.$emit('submit', payload, () => { this.submitting = false; this.handleClose() }, () => { this.submitting = false })
    },
    goToInterview () {
      this.handleClose()
      try {
        this.$router.push({ name: 'interview_ing' })
      } catch (e) {
        this.$router.push('/interview_ing')
      }
    },
    formatInterviewDate (timestamp) {
      if (!timestamp) return ''
      const d = new Date(timestamp)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    formatResumeMeta (resume) {
      const size = resume.size || resume.resume_size || ''
      const time = resume.uploadTime || resume.create_time || ''
      const date = time ? this.formatInterviewDate(time) : ''
      if (date && size) return `${date} · ${size}`
      return date || ''
    }
  }
}
</script>

<style scoped>
.submit-content { padding: 4px 0; }
.section { display: flex; flex-direction: column; }
.section-title { font-size: 14px; font-weight: 600; color: #333; margin: 0 0 8px; }
.material-list { display: flex; flex-direction: column; gap: 10px; overflow-y: auto; }
.single-section .material-list { max-height: 50vh; }
.material-item { display:flex; align-items:center; padding:12px; border:1px solid #e0e0e0; border-radius:10px; cursor:pointer; transition:all .2s; }
.material-item.active { border-color:#B16EF9; background: rgba(177,110,249,.05); box-shadow: 0 4px 12px rgba(177,110,249,.1); }
.material-icon { width:40px; height:40px; margin-right:12px; background: rgba(177,110,249,.08); border-radius:8px; }
.material-info { flex:1; display:flex; flex-direction:column; }
.material-name { font-size:14px; font-weight:600; color:#333; }
.material-date { font-size:12px; color:#888; }
.material-radio { margin-left: 8px; }

.loading-container { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:40px 20px; min-height:200px; }
.loading-spinner { width:40px; height:40px; border:3px solid #f3f3f3; border-top:3px solid #B16EF9; border-radius:50%; animation: spin 1s linear infinite; margin-bottom:16px; }
@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }
.loading-text { font-size:14px; color:#666; text-align:center; }
.empty-block { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:36px 16px; min-height:200px; text-align:center; }
.empty-icon { font-size:42px; margin-bottom:8px; }
.empty-title { font-size:16px; font-weight:600; color:#333; margin-bottom:6px; }
.empty-desc { font-size:13px; color:#777; margin-bottom:14px; }
</style>

<style scoped>
/* 无遮罩内联模式样式 */
.submit-inline {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  top: 10vh;
  width: 480px;
  max-height: 80vh;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 12px 32px rgba(0,0,0,.15);
  display: flex;
  flex-direction: column;
  z-index: 2100;
}
.inline-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
}
</style>

<style scoped>
/* 统一限制对话框在视口内的高度，并让内容在内部滚动，防止页面不同场景撑到底部 */
/* 统一控制 wrapper 居中与顶部间距，避免落到左下角 */
::v-deep .el-dialog__wrapper {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center !important;
  box-sizing: border-box;
  
}
::v-deep .el-dialog__body{
    padding: 0 20px;
}
::v-deep .el-dialog__header{
  font-size: 24px;
  color: #656587;
}
.dialog-title{
  display: flex;
  justify-content: space-between;
}
::v-deep .el-dialog__title{
  
  color: #656587;
  width:100%
}
::v-deep .dialog-footer{
    position: sticky;
    bottom: 0;
    background-color: rgba(255, 255, 255, .72);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    z-index: 1;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    max-height: 100px;
    min-height: 70px;
    .el-button{
        flex: 1;
    }
}
</style>

